import { isValidURL } from './regex';

export const splitFirstOccurrence = (
  str: string,
  separator: string,
): { first: string; remainder: string } => {
  const [first, ...rest] = (str || '').split(separator);
  const remainder = rest.join(' ');
  return { first, remainder };
};

export const hasTimePassed = (date: Date, minutes: number = 7) => {
  if (!date) return false;
  const currentTime = new Date();
  const thresholdTime = new Date(date.getTime() + minutes * 60000);
  return currentTime > thresholdTime;
};

export const getFirstNameLastInitial = (name?: string) => {
  const { first, remainder } = splitFirstOccurrence(name || '', ' ');
  return `${first}${remainder ? ` ${remainder[0]}` : ''}`;
};

export const sortNamesAlphabetically = (names: string[]) =>
  names.slice().sort((a, b) => a.localeCompare(b));

export const getShowingIdAndTypeFromUrl = () => {
  const url = new URL(window.location.href);
  const queryParams = new URLSearchParams(url.search);
  const showingId = queryParams.get('showing');
  const type = queryParams.get('type');
  return { showingId, type };
};

export const formatPhoneNumber = (phone: string): string | undefined => {
  if (!phone) return undefined;

  const digits = phone.replace(/\D/g, '');

  if (digits.length !== 10) return undefined;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const hexToRgba = (hex: string, opacity: number): string => {
  if (!hex) return '';

  hex = hex.replace(/^#/, '');

  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  return opacity ? `rgba(${r}, ${g}, ${b}, ${opacity})` : `rgb(${r}, ${g}, ${b})`;
};

export const getYouTubeThumbnail = (youTubeLink): string | null => {
  if (!youTubeLink || !isValidURL(youTubeLink)) return null;

  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/;
  if (!youtubeRegex.test(youTubeLink)) return null;

  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = youTubeLink.match(regExp);

  if (!match || match[2].length !== 11) return null;

  const videoId = match[2];
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  return thumbnailUrl;
};

export const trimUsa = (addressString) => {
  if (!addressString) return addressString;

  const sub = ', USA';

  if (addressString.endsWith(sub)) {
    return addressString.slice(0, -sub.length);
  }
  return addressString;
};
